import { render, staticRenderFns } from "./CommonDialogTable.vue?vue&type=template&id=4b1a47f3&scoped=true&"
import script from "./CommonDialogTable.vue?vue&type=script&lang=js&"
export * from "./CommonDialogTable.vue?vue&type=script&lang=js&"
import style0 from "./CommonDialogTable.vue?vue&type=style&index=0&id=4b1a47f3&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b1a47f3",
  null
  
)

export default component.exports